import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

const { apiUrl } = environment;

@Injectable({
  providedIn: 'root',
})
export class WarehouseApiService {
  private readonly httpClient = inject(HttpClient);

  sellDevice$(installerId: number, sim1: string): Observable<any> {
    return this.httpClient.post(
      `${apiUrl}/p/warehouse/wapi/devices/setIsSold?sim1=${sim1}`,
      {
        installerId,
        sim1,
        isSold: true,
      },
    );
  }

  unSellDevice$(installerId: number, sim1: string): Observable<any> {
    return this.httpClient.post(
      `${apiUrl}/p/warehouse/wapi/devices/setIsSold?sim1=${sim1}`,
      {
        installerId,
        sim1,
        isSold: false,
      },
    );
  }

  /**
   * Проверить возможность списания устройства со склада
   */
  checkDeviceSoldAttempt$(installerId: number, sim1: string): Observable<any> {
    return this.httpClient.post(
      `${apiUrl}/p/warehouse/wapi/devices/checkByInstallerId?sim1=${sim1}`,
      {
        installerId,
        sim1,
        isSold: true,
      },
    );
  }
}
